import AdminTemplate from 'components/templates/AdminTemplate';
import React, { useState, useEffect } from 'react';
import { Button, Card, CardContent, CircularProgress, Divider, Grid, TextField, Typography } from '@material-ui/core';
import { iProviders } from 'interfaces/imProviders.interface';
import useProvidersIM from 'hooks/useProvidersIM';
import { Controller, useForm } from 'react-hook-form';
import useStyles from './CrossingInvoices.styles';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Autocomplete } from '@material-ui/lab';
import useCrossingInvoices from 'hooks/useCrossingInvoices';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { download } from 'utils/downloadXlsx';
const defaultProvider: any = {
  id: '',
  name: ''
};
const CrossingInvoices = () => {
  const [providers, setProviders] = useState<iProviders[]>([]);
  const { getProvidersActive } = useProvidersIM();
  const form = useForm<{
    dropshipper: string;
    endDate: Date;
    initialDate: Date;
  }>({
    defaultValues: {
      endDate: new Date(),
      initialDate: new Date()
    }
  });
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [provider, setProvider] = useState(defaultProvider);
  const [file, setFile] = useState<string | Blob>('');
  const [fileValue, setFileValue] = useState('');
  const { showNotistack } = useCustomSnackbar();
  const { getInvoices, uploadInvoices } = useCrossingInvoices();

  const getAllProviders = () => {
    getProvidersActive().then((result: iProviders[]) => {
      if (result) {
        setProviders(result);
      }
    });
  };
  useEffect(() => {
    getAllProviders();
  }, []);
  const onSubmit = async (data: { dropshipper: string; endDate: Date; initialDate: Date }) => {
    setIsLoading(true);
    try {
      const response = await getInvoices(provider.name || '', data.endDate, data.initialDate);
      if (response.status) {
        download(response.base64, 'cruceFacturas.xlsx');
      } else {
        showNotistack({ message: response.msg ? response.msg : 'Ocurrio un error' });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showNotistack({ message: 'Ocurrio un error' });
    }
  };
  const uploadFile = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await uploadInvoices(formData);
      if (response.status) {
        setFile('');
        setFileValue('');
        showNotistack({ message: 'Subido correctamente', variant: 'success' });
      } else {
        setFile('');
        setFileValue('');
        showNotistack({ message: response.errors[0], variant: 'error' });
      }
      setIsLoading(false);
    } catch (error) {
      setFile('');
      setFileValue('');
      setIsLoading(false);
      showNotistack({ message: 'Ocurrio un error' });
    }
  };
  return (
    <AdminTemplate>
      <React.Fragment>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h5" component="h5" align="center">
              Cruce de facturas
            </Typography>
          </Grid>
          <Card className={classes.card} elevation={2}>
            <CardContent>
              <Typography variant="h6" component="h6" align="center">
                Descargar reporte
              </Typography>
              <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
                <Grid spacing={2} container>
                  <Grid item xs={3}>
                    <Autocomplete
                      value={provider}
                      fullWidth
                      getOptionLabel={(option: any) => (option.name ? option.name : '')}
                      onChange={(_, value: string | null) => {
                        setProvider(value ? value : '');
                      }}
                      id="providers"
                      options={providers}
                      className={classes.marginFields}
                      renderInput={(params) => (
                        <TextField {...params} required label="Proveedores" name="providers" variant="outlined" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      control={form.control}
                      name="initialDate"
                      rules={{ required: true }}
                      render={(props) => {
                        return (
                          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              variant="inline"
                              inputVariant="outlined"
                              className={classes.date}
                              format="MM/dd/yyyy"
                              margin="normal"
                              fullWidth
                              error={form.errors.initialDate ? true : false}
                              helperText={form.errors.initialDate ? 'Este campo es requerido' : ''}
                              label="Fecha Inicial"
                              value={props.value}
                              autoOk={true}
                              onChange={props.onChange}
                            />
                          </MuiPickersUtilsProvider>
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      control={form.control}
                      name="endDate"
                      rules={{ required: true }}
                      render={(props) => {
                        return (
                          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              variant="inline"
                              inputVariant="outlined"
                              className={classes.date}
                              format="MM/dd/yyyy"
                              margin="normal"
                              fullWidth
                              error={form.errors.endDate ? true : false}
                              helperText={form.errors.endDate ? 'Este campo es requerido' : ''}
                              label="Fecha Final"
                              value={props.value}
                              autoOk={true}
                              onChange={props.onChange}
                            />
                          </MuiPickersUtilsProvider>
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      disabled={isLoading}
                      type="submit"
                      variant="contained"
                      color="primary"
                      style={{ marginTop: 25 }}
                    >
                      {isLoading && (
                        <CircularProgress
                          size={24}
                          style={{ marginRight: 10, width: 16, height: 16, position: 'relative' }}
                        />
                      )}
                      Descargar
                    </Button>
                    <Button variant="contained" color="primary" style={{ marginTop: 25, marginLeft: 10 }}>
                      <a
                        href={'/cruceFacturas.xlsx'}
                        style={{
                          color: 'white',
                          textDecoration: 'none'
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        download="cruceFacturas.xlsx"
                      >
                        Descargar Plantilla
                      </a>
                    </Button>
                  </Grid>
                </Grid>
              </form>
              <br />
              <Divider />
              <br />
              <Typography variant="h6" component="h6" align="center">
                Cargar plantilla
              </Typography>
              <Grid container>
                <Grid item xs={3}>
                  <TextField
                    onChange={(e: any) => {
                      setFileValue(e.target.value);
                      setFile(e.target.files[0]);
                    }}
                    variant="outlined"
                    value={fileValue}
                    type="file"
                    inputProps={{ accept: 'application/xlsx' }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button
                    onClick={uploadFile}
                    disabled={isLoading}
                    variant="contained"
                    color="primary"
                    style={{ marginTop: 8 }}
                  >
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        style={{ marginRight: 10, width: 16, height: 16, position: 'relative' }}
                      />
                    )}
                    Cargar
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </React.Fragment>
    </AdminTemplate>
  );
};
export default CrossingInvoices;
